import { render, staticRenderFns } from "./match-list.vue?vue&type=template&id=d0e0a7a2&scoped=true&"
import script from "./match-list.vue?vue&type=script&lang=js&"
export * from "./match-list.vue?vue&type=script&lang=js&"
import style0 from "./match-list.vue?vue&type=style&index=0&id=d0e0a7a2&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e0a7a2",
  null
  
)

component.options.__file = "match-list.vue"
export default component.exports